module.exports = __webpack_public_path__ + "static/images/tutorial-2.5e99dd853b3ff10b40054969ac5d6447.svg";